import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import styles from './PublicFooter.module.css';

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Brand column */}
          <div className={styles.brandCol}>
            <div className={styles.branding}>
              <img
                src={`${process.env.PUBLIC_URL}/images/brand/verdekai-linkedin-company-logo.png`}
                alt="VerdeKai"
                className={styles.logo}
              />
              <div className={styles.brandText}>
                <span className={styles.brandName}>VerdeKai</span>
                <p className={styles.tagline}>
                  Repeatable underwriting records for litigation finance.
                </p>
              </div>
            </div>
            <div className={styles.socialLinks}>
              <a
                href="mailto:support@verdekai.com"
                className={styles.socialIcon}
                aria-label="Email"
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
              <a
                href="https://www.linkedin.com/company/verdekai/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>

          {/* Product column */}
          <div className={styles.linkCol}>
            <h4 className={styles.colTitle}>Product</h4>
            <ul className={styles.linkList}>
              <li>
                <button onClick={() => scrollToSection('workflow-section')} className={styles.footerLink}>
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('verdescore-section')} className={styles.footerLink}>
                  Risk Review
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security-section')} className={styles.footerLink}>
                  Security
                </button>
              </li>
            </ul>
          </div>

          {/* Company column */}
          <div className={styles.linkCol}>
            <h4 className={styles.colTitle}>Company</h4>
            <ul className={styles.linkList}>
              <li>
                <a href="mailto:support@verdekai.com?subject=VerdeKai%20Beta%20Access" className={styles.footerLink}>
                  Request Beta Access
                </a>
              </li>
              <li>
                <a href="mailto:support@verdekai.com" className={styles.footerLink}>
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/verdekai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLink}
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          {/* Legal column */}
          <div className={styles.linkCol}>
            <h4 className={styles.colTitle}>Legal</h4>
            <ul className={styles.linkList}>
              <li>
                <Link to="/privacy" className={styles.footerLink}>Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className={styles.footerLink}>Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.divider}></div>

        <p className={styles.copyright}>
          &copy; {currentYear} VerdeKai. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default PublicFooter;
